"use client";

import { notFound } from "next/navigation";
import { useTranslations } from "next-intl";
import type { ICountry } from "@/lib/shared/constants";
import type { ProductForClient } from "@/lib/shared/types/interfaces";
import { BackNav, Container, HStack, Separator, VStack } from "@/ui";
import { ProductDetails } from "./ProductDetails";
import { ProductsSlider } from "./ProductsSlider";

export const ProductDetailsContainer = ({
  product,
  initialCountry,
}: {
  product?: ProductForClient;
  initialCountry?: ICountry;
}) => {
  const generalT = useTranslations("general");

  if (!product) return notFound();

  return (
    <Container>
      <BackNav onBack={() => window.history.back()} />
      <ProductDetails
        product={product}
        initialCountry={initialCountry}
      />
      {product.relatedProducts && product.relatedProducts.length > 0 && (
        <VStack className={"mt-8"}>
          <HStack className="items-center gap-4 mb-6 sm:px-12 md:px-24">
            <Separator className="flex-1 bg-border/30" />
            <span className="text-[11px] font-medium uppercase tracking-[0.15em] text-muted-foreground whitespace-nowrap">
              {generalT("may_like")}
            </span>
            <Separator className="flex-1 bg-border/30" />
          </HStack>
          <ProductsSlider
            ariaLabel={generalT("may_like")}
            className={"sm:px-12 md:px-24"}
            products={product.relatedProducts.filter(
              (p): p is ProductForClient => p != null && "variants" in p,
            )}
          />
        </VStack>
      )}
    </Container>
  );
};
